define('views/modules/calendar/animated-session/tags/manager/list/custom-tag-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'bootbox', 'utils',
    // services
    'services/i18n',
    // views
    'views/parts/media-info-box',
    // templates
    'text!templates/modules/calendar/animated-session/tags/list/custom-tag-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, Bootbox, U,
    // services
    i18n,
    // views
    VMediaInfoBox,
    // templates
    TCustomTagListItem
) {

    var VCustomTagListItem = Backbone.View.extend({
        template: TCustomTagListItem,

        regions: {
            infobox: ".item-section",
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            this.view = {
                infobox: new VMediaInfoBox({
                    title: 'name',
                    subtitle: 'description',
                    model: this.model,
                    context: this,
                    onClick: this.onTagClick,
                    menu: {
                        init: this.onMenuInit,
                        onClick: this.onActionClick,
                    }
                }),
            };

            this.listenTo(this.model, {
                'remove': this.remove,
            });
        },
        render: function() {

            this.$el.empty()
                .append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones()
                .assign(this.view.infobox, this.regions.infobox);
            // needs menu regions from infobox el

            return this;
        },

        deleteCustomTag: function(result) {
            if (!result) return;
            this.model.destroy({
                context: this,
                wait: true,
                error: function(model, response) {
                    var json = response.responseJSON;
                    if (json) U.warn(json.message);
                }
            });

        },

        ////////////
        // events //
        ////////////

        onMenuInit: function() {
            return new Backbone.Collection([
                { caption: 'Delete', icon: "sl-icon-trash", callback: this.onDeleteAction }
            ]);
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onAddExerciseClick: function() {
            this.model.trigger('add:exercise:click');
        },

        onTagClick: function(e) {
            this.model.trigger('tag:click', this.model);
        },

        onDeleteAction: function() {
            Bootbox.confirm({
                title: i18n.t("calendar:Delete custom tag"),
                message: i18n.t("messages:message-delete-custom-tag"),
                onEscape: true,
                backdrop: true,
                callback: this.deleteCustomTag,
                context: this,
            });
        },

    });

    return VCustomTagListItem;

});

